// extracted by mini-css-extract-plugin
export default {"historyContainer":"Games_historyContainer__DvnTM","historyBar":"Games_historyBar__i7iEd"};